import { validations } from './validations';

const occasionStatements = [
  'em-um-churrasco',
  'bar-com-os-amigos-ou-happy-hour',
  'em-uma-comemoracao',
  'em-um-jantar-em-casa',
  'em-um-encontro',
  'em-uma-noitada-balada',
  'carnaval-festival',
  'em-evento-esportivo',
  'sozinho-em-casa',
];

/**
 * Questions about beer preferences and ratings
 */
export const beerPreferencesQuestions = [
  {
    id: 'beer-drinks-preferences-rating',
    question: 'Considerando diferentes ocasiões, identifique o quanto você considera consumir cerveja ou outras bebidas nesse contexto',
    subtitle: 'Sendo que<br/>1 = Somente OUTRAS bebidas<br/>5 = Somente CERVEJA.',
    type: 'rating',
    statements: [
      { id: 'em-um-churrasco', text: 'Em um churrasco' },
      { id: 'bar-com-os-amigos-ou-happy-hour', text: 'Bar com os amigos ou happy hour' },
      { id: 'em-uma-comemoracao', text: 'Em uma comemoração' },
      { id: 'em-um-jantar-em-casa', text: 'Em um jantar em casa' },
      { id: 'em-um-encontro', text: 'Em um encontro' },
      { id: 'em-uma-noitada-balada', text: 'Em uma noitada / balada' },
      { id: 'carnaval-festival', text: 'Carnaval / Festival' },
      { id: 'em-evento-esportivo', text: 'Em evento esportivo' },
      { id: 'sozinho-em-casa', text: 'Sozinho em casa' },
    ],
    minRating: 1,
    maxRating: 5,
    ratingLabels: {
      1: 'Somente OUTRAS bebidas',
      5: 'Somente CERVEJA'
    },
    nextQuestion: (answer, allAnswers) => {
      if (allAnswers['common-beer'] === 'somente comuns') {
        return 'why-dont-try-craft-beer';
      }
      return 'beer-preferences-rating';
    },
    validation: validations.ratingComplete(occasionStatements)
  },
  {
    id: 'beer-preferences-rating',
    question: 'E se formos considerar somente a opção de cerveja? Considerando diferentes ocasiões, identifique o quanto você considera consumir Cerveja Comum ou Cervejas Especiais/Artesanais nesses contextos.',
    subtitle: 'Sendo que<br/>1 é sempre cerveja COMUM<br/>5 sempre ESPECIAL',
    type: 'rating',
    statements: [
      { id: 'em-um-churrasco', text: 'Em um churrasco' },
      { id: 'bar-com-os-amigos-ou-happy-hour', text: '      Bar com os amigos ou happy hour' },
      { id: 'em-uma-comemoracao', text: '      Em uma comemoração' },
      { id: 'em-um-jantar-em-casa', text: '      Em um jantar em casa' },
      { id: 'em-um-encontro', text: '      Em um encontro' },
      { id: 'em-uma-noitada-balada', text: '      Em uma noitada / balada' },
      { id: 'carnaval-festival', text: '      Carnaval / Festival' },
      { id: 'em-evento-esportivo', text: '      Em evento esportivo' },
      { id: 'sozinho-em-casa', text: '      Sozinho em casa' },
    ],
    minRating: 1,
    maxRating: 5,
    ratingLabels: {
      1: 'Sempre COMUM',
      5: 'Sempre ESPECIAL'
    },
    nextQuestion: (answer, allAnswers) => {
      if (allAnswers['common-beer'] === 'somente comuns') {
        return 'why-dont-try-craft-beer';
      }
      return 'first-craft-style';
    },
    validation: validations.ratingComplete(occasionStatements)
  },
];
